import { createContext } from 'react';
const AccordionItemContext = createContext({
    id: '',
});
export { AccordionItemContext };
